export const ALERTS = 'alerts';
export const EMERGENCY_CALLS = 'calls';
